import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

export default function Content() {
  return (
    <Accordion className="w-full" collapsible type="single">
      <AccordionItem className="border-[#F3E8FC] border-b" value="item-1">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Qual o tempo mínimo e máximo de conclusão do curso?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          O tempo mínimo é de 4 meses e o tempo máximo é de 18 meses.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-2">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          É obrigatório a entrega do trabalho de conclusão de curso (TCC) ?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          Não, o TCC é opcional.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-3">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Quem pode realizar a inscrição do curso?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          Para realizar a inscrição é necessário que o aluno apresente o diploma
          de ensino superior.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-4">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Quais as opções de pagamento?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          As formas de pagamento estão disponíveis na modalidade Pix, Cartão de
          crédito em até 12x sem juros e Boleto parcelado em até 3x.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem className="border-[#F3E8FC] border-b" value="item-5">
        <AccordionTrigger className="text-start font-medium text-[#64686D] text-lg hover:no-underline">
          Terá tutores me acompanhando durante todo o curso?
        </AccordionTrigger>
        <AccordionContent className="ml-4 font-normal text-[#ABACAD] text-sm">
          Com certeza, você terá tutores disponíveis toda semana te dando
          suporte e orientação garantindo uma experiência educacional
          personalizada e de alto nível.
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
